import Markdown from 'react-markdown';
import rehypeRaw from 'rehype-raw';
import gfm from 'remark-gfm';
import tw, { css } from 'twin.macro';
import 'styled-components/macro';

import { defaultComponents } from 'support/markdown';

export interface ChallengeNoteProps {
  className?: string;
  content: string;
}

export const ChallengeNote = ({ content, className }: ChallengeNoteProps) => (
  <div tw="flex h-full items-center justify-center w-full">
    <Markdown
      tw="text-white"
      css={additionalRichTextStyle}
      className={className}
      remarkPlugins={[gfm]}
      rehypePlugins={[rehypeRaw]}
      components={defaultComponents}
    >
      {content}
    </Markdown>
  </div>
);

// There is a copy of these styles in ChallengesNotesEditorPreview. Don't forget to update those in case of changes
export const additionalRichTextStyle = css`
  font-size: 1.2rem;
  font-weight: 300;

  h1 {
    font-family: 'Libre Franklin';
    font-weight: 600;
    font-size: 1.5em;
    line-height: 1.5em;
  }

  h2 {
    font-family: 'Libre Franklin';
    font-weight: 400;
  }

  strong {
    font-weight: 600;
  }

  p {
    margin: 20px 0;
    line-height: 1.3em;
  }

  img {
    max-width: 100%;
  }

  code {
    ${tw`bg-blue-light text-gray-5`}
    font-size: 1em;
    border-radius: 5px;
    white-space: pre-wrap;
    padding: 0.2em;
  }

  pre {
    ${tw`bg-blue-light`}
    border-radius: 5px;
    padding: 0.5em;
    box-sizing: border-box;
    line-height: 1.2em;

    > code {
      padding: 0;
    }
  }

  a {
    color: inherit;
    text-decoration: underline;
  }

  @media (min-width: 768px) {
    max-width: 90%;
  }

  @media (min-width: 1024px) {
    font-size: 1.3rem;
    max-width: 80%;
  }

  @media (min-width: 1440px) {
    font-size: 1.7rem;
    max-width: 80%;
  }

  @media (min-width: 1920px) {
    font-size: 2rem;
    max-width: 70%;
  }

  ul {
    margin: 20px 0;
    padding-left: 2em;
    list-style-type: revert;
    list-style-position: outside;
  }

  ol {
    margin: 20px 0;
    padding-left: 2em;
    list-style-type: decimal;
    list-style-position: outside;
  }

  li {
    line-height: 1.3em;
    padding-left: 0.3em;
  }

  blockquote {
    ${tw`border-l-5 border-gray-5`}
    padding-left: 0.5em;
  }

  table {
    font-size: 0.8em;
    border-collapse: collapse;
  }

  table,
  th,
  td {
    ${tw`border border-white`}
    padding: 0.4em;
  }
`;
